// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastPlayer-cls1_Lth","cls2":"PodcastPlayer-cls2_7_E PodcastPlayer-cls1_Lth"};